import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.projects.group');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-projects-group',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.projects.group/view.scss */
/* src/app/page.projects.group/view.scss: no such file or directory */`],
})
export class PageProjectsGroupComponent implements OnInit, OnDestroy {
    public groups: any[] = [];
    public selectedGroup: any = null;
    public projects: any[] = [];
    public groupStatusFilter: string = 'active';
    public projectStatusFilter: string = 'active';
    public projectTypeFilter: string = 'all';
    public groupStatusCounts: any = { active: 0, archived: 0, disabled: 0 };
    public projectStatusCounts: any = { active: 0, archived: 0, disabled: 0 };
    public loading: boolean = true;
    public filters: any = { text: '', mine: 'explore', label: '', group_label: '' };
    public tagFilterOpen: boolean = false;
    public tagFilterQuery: string = '';
    public groupTagFilterOpen: boolean = false;
    public groupTagFilterQuery: string = '';
    public projectPage: number = 1;
    public projectPageSize: number = 10;
    public groupPage: number = 1;
    public groupPageSize: number = 12;
    public projectCatalogAllowed: boolean = true;
    public adminMode: boolean = false;
    public requestingJoin: boolean = false;
    public leavingGroup: boolean = false;
    public approvingJoinRequestId: string = '';
    public rejectingJoinRequestId: string = '';
    public projectStatusOptions: any[] = [
        { value: 'active', label: '활성' },
        { value: 'archived', label: '보관' },
        { value: 'disabled', label: '비활성' }
    ];
    public projectTypeFilterOptions: any[] = [
        { value: 'all', label: '전체' },
        { value: 'pdf', label: 'PDF' },
        { value: 'html', label: 'HTML' },
        { value: 'web_service', label: '웹서비스' },
    ];
    public groupScopeOptions: any[] = [
        { value: 'explore', label: '탐색' },
        { value: 'participating', label: '참여 그룹' }
    ];
    public loadedRouteKey: string = '';
    private routeSubscription: any = null;
    private workspaceDetached: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/login');
        this.applyRouteFilters();
        this.adminMode = this.routeAdminMode();
        this.loadedRouteKey = this.routeKey();
        this.routeSubscription = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.handleRouteChange(event.urlAfterRedirects || event.url || location.pathname);
            }
        });
        await this.load();
    }

    public ngOnDestroy() {
        if (this.routeSubscription && this.routeSubscription.unsubscribe) this.routeSubscription.unsubscribe();
        this.routeSubscription = null;
    }

    public reviewopsWorkspaceDetached() {
        this.workspaceDetached = true;
    }

    public reviewopsWorkspaceAttached() {
        this.workspaceDetached = false;
    }

    public routeAdminMode(path: string = `${location.pathname}${location.search}`) {
        try {
            const query = String(path || '').split('?')[1] || '';
            return new URLSearchParams(query).get('admin') === '1';
        } catch (e) {
            return false;
        }
    }

    public normalizedGroupScope(value: string) {
        const scope = String(value || '').trim().toLowerCase();
        return scope === 'participating' ? 'participating' : 'explore';
    }

    public routeGroupScope(path: string = `${location.pathname}${location.search}`) {
        try {
            const query = String(path || '').split('?')[1] || '';
            const params = new URLSearchParams(query);
            return this.normalizedGroupScope(params.get('mine') || params.get('scope') || this.filters.mine);
        } catch (e) {
            return this.normalizedGroupScope(this.filters.mine);
        }
    }

    public applyRouteFilters(path: string = `${location.pathname}${location.search}`) {
        this.filters.mine = this.routeGroupScope(path);
    }

    public routeKey(path: string = `${location.pathname}${location.search}`) {
        const cleanPath = String(path || '').split('?')[0];
        return `${cleanPath}|${this.routeAdminMode(path) ? 'admin' : 'user'}|${this.routeGroupScope(path)}`;
    }

    public async handleRouteChange(path: string = `${location.pathname}${location.search}`) {
        if (this.workspaceDetached) return;
        const nextKey = this.routeKey(path);
        if (!this.loadedRouteKey) {
            this.loadedRouteKey = nextKey;
            return;
        }
        if (nextKey === this.loadedRouteKey) {
            await this.service.render();
            return;
        }
        this.loadedRouteKey = nextKey;
        this.applyRouteFilters(path);
        this.adminMode = this.routeAdminMode(path);
        this.tagFilterOpen = false;
        this.groupTagFilterOpen = false;
        this.resetGroupPagination();
        this.resetProjectPagination();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.filters.mine = this.normalizedGroupScope(this.filters.mine);
        this.groups = [];
        this.projects = [];
        this.calculateGroupStatusCounts();
        this.calculateProjectStatusCounts();
        await this.service.render();

        const groupId = this.selectedGroupId();
        const { code, data } = await wiz.call('load', Object.assign({}, this.filters, {
            group_id: groupId,
            project_text: this.filters.text || '',
            admin: this.adminMode ? '1' : ''
        }));
        if (code === 200) {
            this.projectCatalogAllowed = data.can_use_project_catalog !== false;
            if (!this.adminMode && !this.projectCatalogAllowed && !this.isParticipatingScope()) {
                location.href = '/projects/participating';
                return;
            }
            this.groups = data.groups || [];
            this.selectedGroup = data.group || null;
            this.projects = data.projects || [];
            this.calculateGroupStatusCounts();
            this.calculateProjectStatusCounts();
            this.ensureGroupPage();
            this.ensureProjectPage();
        } else {
            await this.service.modal.error(data.message || '프로젝트 그룹을 불러오지 못했습니다.');
        }

        this.loading = false;
        await this.service.render();
    }

    public calculateProjectStatusCounts() {
        const counts: any = { active: 0, archived: 0, disabled: 0 };
        for (const project of this.projects) {
            const status = project && project.status ? project.status : 'active';
            if (counts[status] === undefined) counts[status] = 0;
            counts[status] += 1;
        }
        this.projectStatusCounts = counts;
    }

    public calculateGroupStatusCounts() {
        const counts: any = { active: 0, archived: 0, disabled: 0 };
        for (const group of this.groups) {
            const status = group && group.status ? group.status : 'active';
            if (counts[status] === undefined) counts[status] = 0;
            counts[status] += 1;
        }
        this.groupStatusCounts = counts;
    }

    public async setGroupStatusFilter(value: string) {
        this.groupStatusFilter = value || 'active';
        this.resetGroupPagination();
        await this.service.render();
    }

    public async setProjectStatusFilter(value: string) {
        this.projectStatusFilter = value || 'active';
        this.resetProjectPagination();
        await this.service.render();
    }

    public async setProjectTypeFilter(value: string) {
        this.projectTypeFilter = value || 'all';
        this.resetProjectPagination();
        await this.service.render();
    }

    public async searchProjects() {
        this.resetGroupPagination();
        this.resetProjectPagination();
        await this.load();
    }

    public syncGroupScopeUrl() {
        if (this.adminMode || this.showingGroupProjects()) return;
        const query = this.queryString(this.groupScopeQueryParams());
        const next = query ? `${this.groupListPath()}?${query}` : this.groupListPath();
        if (`${location.pathname}${location.search}` !== next) {
            history.replaceState(history.state, '', next);
            this.loadedRouteKey = this.routeKey(next);
        }
    }

    public async setGroupScope(value: string) {
        this.filters.mine = this.normalizedGroupScope(value);
        this.syncGroupScopeUrl();
        await this.searchProjects();
    }

    public isParticipatingScope() {
        return this.filters.mine === 'participating';
    }

    public selectedGroupId() {
        return this.groupIdFromPath();
    }

    public groupIdFromPath(path: string = location.pathname) {
        const cleanPath = String(path || '').split('?')[0];
        const match = cleanPath.match(/^\/projects(?:\/mine|\/participating)?\/group\/([^\/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
    }

    public showingGroupProjects() {
        return !!this.selectedGroupId();
    }

    public groupPath(group: any) {
        return `/projects/group/${group && group.id ? group.id : ''}`;
    }

    public groupScopeQueryParams() {
        if (this.adminMode) return {};
        return this.isParticipatingScope() ? { mine: 'participating' } : {};
    }

    public groupQueryParams() {
        const params: any = Object.assign({}, this.groupScopeQueryParams());
        if (this.adminMode) params.admin = '1';
        return params;
    }

    public groupListPath() {
        if (this.adminMode) return '/admin';
        return '/projects';
    }

    public groupListQueryParams() {
        if (this.adminMode) return { tab: 'groups' };
        return this.groupScopeQueryParams();
    }

    public queryString(params: any) {
        const pairs: string[] = [];
        for (const key of Object.keys(params || {})) {
            const value = params[key];
            if (value === undefined || value === null || value === '') continue;
            pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
        }
        return pairs.join('&');
    }

    public currentGroupPath() {
        const groupId = this.selectedGroupId();
        if (!groupId) return this.groupListPath();
        const path = this.groupPath(this.selectedGroup || { id: groupId });
        const query = this.queryString(this.groupQueryParams());
        return query ? `${path}?${query}` : path;
    }

    public projectDetailPath(project: any, tab: string = '') {
        const id = project && project.id ? project.id : '';
        if (!id) return '/projects';
        return tab === 'review' ? `/projects/${id}/review` : `/projects/${id}`;
    }

    public projectDetailQueryParams() {
        return this.adminMode ? { admin: '1' } : {};
    }

    public rememberProjectReturn(project: any) {
        if (!project || !project.id || !this.showingGroupProjects()) return;
        try {
            const groupId = this.selectedGroupId();
            sessionStorage.setItem(`reviewops_project_return:${project.id}`, JSON.stringify({
                project_id: project.id,
                group_id: groupId,
                path: this.currentGroupPath(),
                saved_at: new Date().toISOString()
            }));
        } catch (e) { }
    }

    public applySelectedGroup(group: any) {
        if (!group) return;
        this.selectedGroup = group;
        const index = this.groups.findIndex((item: any) => item.id === group.id);
        if (index >= 0) this.groups[index] = Object.assign({}, this.groups[index], group);
        this.calculateGroupStatusCounts();
        this.ensureGroupPage();
    }

    public canRequestSelectedGroupJoin() {
        return !!(this.selectedGroup && this.selectedGroup.can_request_join);
    }

    public hasRequestedSelectedGroupJoin() {
        return !!(this.selectedGroup && this.selectedGroup.join_request_status === 'requested');
    }

    public canLeaveSelectedGroup() {
        return !!(this.selectedGroup && this.selectedGroup.can_leave_group);
    }

    public canManageSelectedGroup() {
        return !!(this.selectedGroup && this.selectedGroup.can_manage_members);
    }

    public selectedGroupJoinRequests() {
        if (!this.canManageSelectedGroup()) return [];
        return this.selectedGroup && Array.isArray(this.selectedGroup.join_requests) ? this.selectedGroup.join_requests : [];
    }

    public joinRequestUserLabel(request: any) {
        const user = request && request.user ? request.user : {};
        return user.name || request.email || '-';
    }

    public async requestJoinGroup() {
        if (!this.canRequestSelectedGroupJoin() || this.requestingJoin) return;
        this.requestingJoin = true;
        await this.service.render();
        const { code, data } = await wiz.call('request_join_group', {
            group_id: this.selectedGroupId()
        });
        this.requestingJoin = false;
        if (code === 200) {
            this.applySelectedGroup(data.group);
            await this.service.modal.success('가입 신청을 보냈습니다.');
        } else {
            await this.service.modal.error(data.message || '가입 신청을 처리하지 못했습니다.');
        }
        await this.service.render();
    }

    public async approveJoinRequest(request: any) {
        if (!this.canManageSelectedGroup() || !request || !request.id || this.approvingJoinRequestId) return;
        this.approvingJoinRequestId = request.id;
        await this.service.render();
        const { code, data } = await wiz.call('approve_group_join_request', Object.assign({
            group_id: this.selectedGroupId(),
            request_id: request.id
        }, this.groupQueryParams()));
        this.approvingJoinRequestId = '';
        if (code === 200) {
            this.applySelectedGroup(data.group);
            await this.service.modal.success('가입 신청을 승인했습니다.');
        } else {
            await this.service.modal.error(data.message || '가입 신청을 승인하지 못했습니다.');
        }
        await this.service.render();
    }

    public async rejectJoinRequest(request: any) {
        if (!this.canManageSelectedGroup() || !request || !request.id || this.rejectingJoinRequestId) return;
        const ok = await this.service.modal.show({
            title: '가입 신청 거절',
            message: `${this.joinRequestUserLabel(request)} 님의 가입 신청을 거절할까요?`,
            action: '거절',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.rejectingJoinRequestId = request.id;
        await this.service.render();
        const { code, data } = await wiz.call('reject_group_join_request', Object.assign({
            group_id: this.selectedGroupId(),
            request_id: request.id
        }, this.groupQueryParams()));
        this.rejectingJoinRequestId = '';
        if (code === 200) {
            this.applySelectedGroup(data.group);
        } else {
            await this.service.modal.error(data.message || '가입 신청을 거절하지 못했습니다.');
        }
        await this.service.render();
    }

    public async leaveGroup() {
        if (!this.canLeaveSelectedGroup() || this.leavingGroup) return;
        const ok = await this.service.modal.show({
            title: '그룹 탈퇴',
            message: `${this.selectedGroup.name} 그룹에서 탈퇴할까요?`,
            action: '탈퇴',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!ok) return;
        this.leavingGroup = true;
        await this.service.render();
        const { code, data } = await wiz.call('leave_group', {
            group_id: this.selectedGroupId()
        });
        this.leavingGroup = false;
        if (code === 200) {
            if (data.group && !data.group.left) {
                this.applySelectedGroup(data.group);
            } else {
                await this.load();
            }
            await this.service.modal.success('그룹에서 탈퇴했습니다.');
        } else {
            await this.service.modal.error(data.message || '그룹을 탈퇴하지 못했습니다.');
        }
        await this.service.render();
    }

    public filteredGroups() {
        const status = this.groupStatusFilter || 'active';
        const text = String(this.filters.text || '').trim().toLowerCase();
        const label = String(this.filters.group_label || '').trim().toLowerCase();
        return this.groups.filter((group) => {
            const groupStatus = group && group.status ? group.status : 'active';
            if (groupStatus !== status) return false;
            if (label && !this.groupLabels(group).some((item) => item.toLowerCase() === label)) return false;
            if (!text) return true;
            return this.groupMatchesSearch(group, text);
        });
    }

    public visibleGroups() {
        const rows = this.filteredGroups();
        const start = (this.groupPage - 1) * this.groupPageSize;
        return rows.slice(start, start + this.groupPageSize);
    }

    public groupTotalCount() {
        return this.filteredGroups().length;
    }

    public groupTotalPages() {
        const total = Math.ceil(this.groupTotalCount() / this.groupPageSize);
        return Math.max(total || 1, 1);
    }

    public groupPageStart() {
        const total = this.groupTotalCount();
        if (!total) return 0;
        return (this.groupPage - 1) * this.groupPageSize + 1;
    }

    public groupPageEnd() {
        return Math.min(this.groupPage * this.groupPageSize, this.groupTotalCount());
    }

    public groupPageNumbers() {
        const total = this.groupTotalPages();
        const current = Math.min(Math.max(this.groupPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public setGroupPage(page: number) {
        const total = this.groupTotalPages();
        const next = Math.min(Math.max(Number(page) || 1, 1), total);
        if (this.groupPage === next) return;
        this.groupPage = next;
        this.service.render();
    }

    public resetGroupPagination() {
        this.groupPage = 1;
    }

    public ensureGroupPage() {
        this.setGroupPage(this.groupPage);
    }

    public groupStatusBadgeClass(value: string) {
        const visibility = value || 'public';
        if (visibility === 'private') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-slate-900 px-2 py-0.5 text-[11px] font-medium text-white';
        return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
    }

    public visibilityLabel(value: string) {
        return value === 'private' ? '비공개' : '공개';
    }

    public groupEmptyMessage() {
        if (String(this.filters.text || '').trim() || String(this.filters.group_label || '').trim()) return '검색 결과가 없습니다.';
        if (!this.groups.length) {
            return this.isParticipatingScope() ? '참여 그룹이 없습니다.' : '탐색 가능한 공개 그룹이 없습니다.';
        }
        return `${this.projectStatusLabel(this.groupStatusFilter)} 그룹이 없습니다.`;
    }

    public groupMatchesSearch(group: any, text: string) {
        const owner = group && group.owner ? group.owner : {};
        const haystack = [
            group && group.name,
            group && group.description,
            this.groupLabels(group).join(' '),
            group && group.visibility,
            group && group.status,
            this.projectStatusLabel(group && group.status ? group.status : 'active'),
            owner.name,
            owner.email,
            this.roleLabel(group && group.group_role)
        ].join(' ').toLowerCase();
        return haystack.indexOf(text) >= 0;
    }

    public filteredProjects() {
        const label = String(this.filters.label || '').trim().toLowerCase();
        const type = this.projectTypeFilter || 'all';
        return this.projects.filter((project) => {
            if ((project && project.status ? project.status : 'active') !== this.projectStatusFilter) return false;
            if (type !== 'all' && this.projectTypeValue(project) !== type) return false;
            if (label && !this.projectLabels(project).some((item) => item.toLowerCase() === label)) return false;
            return true;
        });
    }

    public projectTypeValue(project: any) {
        return project && project.project_type ? String(project.project_type) : 'web_service';
    }

    public labelCandidates(value: any): string[] {
        if (value === null || value === undefined) return [];
        if (Array.isArray(value)) {
            let result: string[] = [];
            for (const item of value) result = result.concat(this.labelCandidates(item));
            return result;
        }
        if (typeof value === 'object') {
            for (const key of ['value', 'label', 'text', 'title', 'name']) {
                if (value[key] !== null && value[key] !== undefined) return this.labelCandidates(value[key]);
            }
            return [];
        }
        const text = String(value).trim();
        if (text.startsWith('[') || text.startsWith('{')) {
            try {
                return this.labelCandidates(JSON.parse(text));
            } catch (e) { }
        }
        return [text];
    }

    public normalizeLabel(value: any) {
        const candidates = this.labelCandidates(value);
        let label = String(candidates.length ? candidates[0] : '').trim().replace(/^#+/, '').trim();
        while (label.indexOf('  ') >= 0) label = label.replace(/  /g, ' ');
        const key = label.toLowerCase();
        if (key === 'object' || key === '[object object]') return '';
        return label.slice(0, 40);
    }

    public normalizeLabels(labels: any) {
        let source = labels;
        if (typeof labels === 'string') {
            const text = labels.trim();
            source = text.startsWith('[') || text.startsWith('{') ? labels : text.replace(/\n/g, ',').split(',');
        }
        const result: string[] = [];
        const seen: any = {};
        for (const value of this.labelCandidates(source)) {
            const label = this.normalizeLabel(value);
            const key = label.toLowerCase();
            if (!label || key === 'object' || key === '[object object]' || seen[key]) continue;
            seen[key] = true;
            result.push(label);
            if (result.length >= 12) break;
        }
        return result;
    }

    public projectLabels(project: any) {
        return this.normalizeLabels(project && project.labels);
    }

    public groupLabels(group: any) {
        return this.normalizeLabels(group && group.labels);
    }

    public groupLabelOptions() {
        const labels: string[] = [];
        const seen: any = {};
        for (const group of this.groups) {
            for (const label of this.groupLabels(group)) {
                const value = String(label || '').trim();
                const key = value.toLowerCase();
                if (!value || seen[key]) continue;
                seen[key] = true;
                labels.push(value);
            }
        }
        return labels.sort((a, b) => a.localeCompare(b));
    }

    public filteredGroupLabelOptions() {
        const query = String(this.groupTagFilterQuery || '').trim().toLowerCase();
        return this.groupLabelOptions().filter((label) => !query || label.toLowerCase().includes(query));
    }

    public openGroupLabelFilter() {
        this.groupTagFilterOpen = true;
        this.service.render();
    }

    public closeGroupLabelFilterLater() {
        window.setTimeout(async () => {
            this.groupTagFilterOpen = false;
            await this.service.render();
        }, 120);
    }

    public async selectGroupLabelFilter(label: string) {
        this.filters.group_label = label || '';
        this.groupTagFilterQuery = this.filters.group_label;
        this.groupTagFilterOpen = false;
        this.resetGroupPagination();
        await this.load();
    }

    public async selectFirstGroupLabelFilter() {
        const options = this.filteredGroupLabelOptions();
        if (options.length) await this.selectGroupLabelFilter(options[0]);
    }

    public async clearGroupLabelFilter() {
        this.filters.group_label = '';
        this.groupTagFilterQuery = '';
        this.groupTagFilterOpen = false;
        this.resetGroupPagination();
        await this.load();
    }

    public labelOptions() {
        const labels: string[] = [];
        const seen: any = {};
        for (const project of this.projects) {
            for (const label of this.projectLabels(project)) {
                const value = String(label || '').trim();
                const key = value.toLowerCase();
                if (!value || seen[key]) continue;
                seen[key] = true;
                labels.push(value);
            }
        }
        return labels.sort((a, b) => a.localeCompare(b));
    }

    public filteredLabelOptions() {
        const query = String(this.tagFilterQuery || '').trim().toLowerCase();
        return this.labelOptions().filter((label) => !query || label.toLowerCase().includes(query));
    }

    public openLabelFilter() {
        this.tagFilterOpen = true;
        this.service.render();
    }

    public closeLabelFilterLater() {
        window.setTimeout(async () => {
            this.tagFilterOpen = false;
            await this.service.render();
        }, 120);
    }

    public async selectLabelFilter(label: string) {
        this.filters.label = label || '';
        this.tagFilterQuery = this.filters.label;
        this.tagFilterOpen = false;
        this.resetProjectPagination();
        await this.load();
    }

    public async selectFirstLabelFilter() {
        const options = this.filteredLabelOptions();
        if (options.length) await this.selectLabelFilter(options[0]);
    }

    public async clearLabelFilter() {
        this.filters.label = '';
        this.tagFilterQuery = '';
        this.tagFilterOpen = false;
        this.resetProjectPagination();
        await this.load();
    }

    public visibleProjects() {
        const rows = this.filteredProjects();
        const start = (this.projectPage - 1) * this.projectPageSize;
        return rows.slice(start, start + this.projectPageSize);
    }

    public projectTotalCount() {
        return this.filteredProjects().length;
    }

    public projectTotalPages() {
        const total = Math.ceil(this.projectTotalCount() / this.projectPageSize);
        return Math.max(total || 1, 1);
    }

    public projectPageStart() {
        const total = this.projectTotalCount();
        if (!total) return 0;
        return (this.projectPage - 1) * this.projectPageSize + 1;
    }

    public projectPageEnd() {
        return Math.min(this.projectPage * this.projectPageSize, this.projectTotalCount());
    }

    public projectPageNumbers() {
        const total = this.projectTotalPages();
        const current = Math.min(Math.max(this.projectPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public setProjectPage(page: number) {
        const total = this.projectTotalPages();
        const next = Math.min(Math.max(Number(page) || 1, 1), total);
        if (this.projectPage === next) return;
        this.projectPage = next;
        this.service.render();
    }

    public resetProjectPagination() {
        this.projectPage = 1;
    }

    public ensureProjectPage() {
        this.setProjectPage(this.projectPage);
    }

    public statusTabClass(value: string) {
        const selected = this.projectStatusFilter === value;
        const base = 'reviewops-header-control inline-flex h-9 items-center justify-center gap-1.5 border-r border-slate-200 px-3 text-[12px] font-semibold transition-colors last:border-r-0';
        if (selected) return `${base} bg-slate-900 text-white`;
        return `${base} bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950`;
    }

    public groupStatusTabClass(value: string) {
        const selected = this.groupStatusFilter === value;
        const base = 'reviewops-header-control inline-flex h-9 items-center justify-center gap-1.5 border-r border-slate-200 px-3 text-[12px] font-semibold transition-colors last:border-r-0';
        if (selected) return `${base} bg-slate-900 text-white`;
        return `${base} bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950`;
    }

    public projectTypeFilterTabClass(value: string) {
        const selected = this.projectTypeFilter === value;
        const base = 'inline-flex h-10 items-center justify-center border-b-2 px-3 text-[13px] font-semibold transition-colors';
        if (selected) return `${base} border-slate-950 text-slate-950`;
        return `${base} border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-900`;
    }

    public projectStatusBadgeClass(value: string) {
        const status = value || 'active';
        if (status === 'archived') return 'rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700';
        if (status === 'disabled') return 'rounded-full bg-slate-200 px-2 py-0.5 text-[11px] font-medium text-slate-600';
        return 'rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
    }

    public projectStatusLabel(value: string) {
        const option = this.projectStatusOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public codexStatusLabel(project: any) {
        return project && project.codex_enabled ? '에이전트 활성' : '에이전트 비활성';
    }

    public codexBadgeClass(project: any) {
        if (project && project.codex_enabled) return 'whitespace-nowrap rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
        return 'whitespace-nowrap rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-500';
    }

    public codexAccountEmail(project: any) {
        const account = project && project.codex_status && project.codex_status.account ? project.codex_status.account : {};
        return account.email || account.name || '-';
    }

    public codexSubscriptionLabel(project: any) {
        if (!project || !project.codex_enabled) return '-';
        const status = project.codex_status || {};
        const account = status.account || {};
        const usage = status.usage || {};
        return account.plan || usage.summary || '구독 정보 없음';
    }

    public projectStatusEmptyMessage() {
        if (String(this.filters.text || '').trim() || String(this.filters.label || '').trim()) return '검색 결과가 없습니다.';
        return `${this.projectStatusLabel(this.projectStatusFilter)} 프로젝트가 없습니다.`;
    }

    public roleLabel(role: string) {
        const labels: any = {
            owner: '소유자',
            developer: '관리자',
            reviewer: '리뷰어',
            guest: '손님'
        };
        return labels[role || 'reviewer'] || role;
    }

    public projectTypeLabel(project: any) {
        return project && project.project_type_label ? project.project_type_label : '웹서비스';
    }

    public reviewSummaryCount(summary: any, status: string) {
        if (status === 'total') return Number(summary && summary.total) || 0;
        const byStatus = summary && summary.by_status ? summary.by_status : {};
        return Number(byStatus && byStatus[status]) || 0;
    }

    public reviewSummaryTileClass(summary: any, status: string, activeBg: string, extra: string = '') {
        const base = `${extra ? `${extra} ` : ''}rounded-md px-1.5 py-1.5`;
        return `${base} ${this.reviewSummaryCount(summary, status) > 0 ? activeBg : 'bg-slate-50'}`;
    }

    public reviewSummaryLabelClass(summary: any, status: string, activeText: string, size: string = 'text-[10px]') {
        return `${size} ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public reviewSummaryCountClass(summary: any, status: string, activeText: string) {
        return `text-[13px] font-semibold ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public projectDocumentVersionLabel(project: any) {
        const version = project && project.current_document_version ? project.current_document_version : null;
        const value = version && (version.version_label || version.created);
        return this.service.formatter.kstDateTime(value, value || '-');
    }

    public projectTargetLabel(project: any) {
        if (project && project.is_document_project && project.current_document_version) {
            return `${project.current_document_version.file_name} · ${this.projectDocumentVersionLabel(project)}`;
        }
        return project && project.link_url ? project.link_url : '-';
    }
}

export default PageProjectsGroupComponent;